import React from 'react';
import { flattenToAppURL } from '@plone/volto/helpers';

const getImageSrc = (item, scale = 'preview') => {
  if (!item?.['@id']) return null;
  if (item['@type'] === 'URL') return item['@id'];
  return flattenToAppURL(item['@id']) + `/@@images/image/${scale}`;
};

const vizitkaLinkView = (props) => {
  const { data } = props;
  const firstImage = data.image?.[0];
  const imageSrc = firstImage ? getImageSrc(firstImage) : null;
  return (
    <div className="block ch-vizitka">
      <header className="ch-vizitka-title">
        <h2>{data.title}</h2>
      </header>
      {imageSrc && <img src={imageSrc} alt={firstImage.Title} />}
      <div className="ch-vizitka-text">{data.text}</div>
    </div>
  );
};

export default vizitkaLinkView;
